import { AssetsService } from './AssetsService';

export const assetsService = new AssetsService();
